meedy.run(['$templateCache',
    function($templateCache) {
        $templateCache.put('lib/es-commons/directive/esTabBar/template/es-tab-bar.html',
            '<div class="tabBar">' +
            '<div class="contextContainer" ng-class="{ \'titleOnly\' : !_useBackButton }" ng-if="_useContextBar">' +
            '<button ng-if="_useBackButton" type="button" class="btn btn-sm btn-primary backButton" ng-click="onTabBarBackClick()"><span class="fa fa-reply"></span></button>' +
            '<span ng-if="tabBarTitle" class="tabBarTitle">{{ tabBarTitle | translate }}</span>' +
            '</div>' +
            '<div class="tabContainer paddingTop10" ng-class="{ \'disabled\': _disableTabs }" ng-if="tabBarItems && tabBarItems.length > 0">' +
            '<ul class="nav nav-tabs">' +
            '<li ng-repeat="tabBarItem in tabBarItems" ng-class="{ \'active\': tabBarItem.active}">' +
            '<a ng-if="!_disableTabs" ui-sref="{{ tabBarItem.state + (tabBarItem.stateParameters ? createParameterString(tabBarItem.stateParameters) : \'\' ) }}">' +
            '{{ tabBarItem.name | translate }}' +
            '</a>' +
            '<a ng-if="_disableTabs" href="#" onclick="return false;">' +
            '{{ tabBarItem.name | translate }}' +
            '</a>' +
            '</li>' +
            '</ul>' +
            '</div>' +
            '</div>'
        );
    }
]);
